import React from 'react';
import PropTypes from 'prop-types';
import { values, max, times } from 'lodash-es';

import SmartChart from './SmartChart';
import config from './MapChartConfig';

const breakpointsCount = 7;

const breakpointsColorList = ['#f5f7fa', '#e1e5eb', '#c2c8d3', '#9da8bd', '#848ea1', '#555f77', '#3b4355'];

const MapChart = ({
  chartId,
  legendTitle,
  series,
  tooltipFormatter,
  colorList = breakpointsColorList,
  count = breakpointsCount,
  height,
  tooltipPadding,
  legendEnabled = true,
}) => {
  const mergedSeries = WW_COUNTRIES.map(country => ({ ...country, value: series[country.code] || 0 }));
  const intVal = max(values(series)) / count;
  const dataClasses = [];
  times(count, (i) => {
    if (i === 0) {
      dataClasses[i] = {
        to: 0,
        from: 0,
        color: colorList[i],
      };
    } else if (i === 1) {
      dataClasses[i] = {
        from: 0.1,
        to: intVal,
        color: colorList[i],
      };
    } else {
      dataClasses[i] = {
        to: intVal * (i + 2),
        from: i === 2 ? intVal : intVal * (i + 1),
        color: colorList[i],
      };
    }
  });

  const options = {
    series: mergedSeries, legendTitle, tooltipFormatter, dataClasses, height, tooltipPadding, legendEnabled,
  };

  return (
    <div>
      <SmartChart
        config={config(options)}
        series={{ countries: mergedSeries }}
        metaSeriesData={{ countries: { visible: true } }}
        type="mapChart"
        chartId={chartId}
        className="map-chart show-overflow"
      />
    </div>
  );
};

MapChart.propTypes = {
  chartId: PropTypes.string.isRequired,
  series: PropTypes.object.isRequired,
  legendTitle: PropTypes.string.isRequired,
  colorList: PropTypes.array,
  count: PropTypes.number,
  height: PropTypes.number,
  tooltipPadding: PropTypes.number,
  legendEnabled: PropTypes.bool,
  tooltipFormatter: PropTypes.func.isRequired,
};

export default MapChart;
